import styled from 'styled-components'

import { Colors } from '@utils/Colors'

export const Container = styled.div``

export const Timeline = styled.ol`
  list-style: none;
  margin: 0;
  padding: 0;
`

export const TimelineItem = styled.li`
  display: flex;
  gap: 12px;
  margin-bottom: 24px;

  &:last-child {
    margin-bottom: 0;
  }
`

export const TimelineMarker = styled.span`
  align-items: center;
  background-color: ${Colors.GRAY500};
  border-radius: 50%;
  color: ${Colors.WHITE};
  display: flex;
  flex-shrink: 0;
  font-size: 12px;
  font-weight: 600;
  height: 24px;
  justify-content: center;
  width: 24px;
`

export const TimelineContent = styled.div`
  flex: 1;
`

export const TimelineTitle = styled.p`
  color: ${Colors.GRAY500};
  font-weight: 600;
  margin: 0 0 4px;
`

export const TimelineDescription = styled.p`
  color: ${Colors.GRAY500};
  margin: 0;
`

export const TutorialLink = styled.button`
  background: none;
  border: none;
  color: ${Colors.PRIMARY500};
  cursor: pointer;
  font-size: inherit;
  font-weight: 600;
  margin: 24px 0 0;
  padding: 0;
  text-align: center;
  text-decoration: underline;
  width: 100%;
`

export const WebHeader = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
`

export const HelpButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
`
